export default {"src":"/_next/static/media/apple_en.2bd4fd0b.svg","height":62,"width":192};